import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, ModalController } from 'ionic-angular';

import { Configuration } from '../../constants/config';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import { HomePage } from "../home/home";
import { PosTabsPage } from '../pos-tabs/pos-tabs';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

    user = {user: null, pass: null};
    response: any;
    showLogin = false;
    isLoaderReady = true;
    loader = this.loadingCtrl.create({
        content: "Please wait...",
    });

    constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, public authService: AuthServiceProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public _configuration: Configuration) {
        this.user.user = null;
        this.user.pass = null;
        this._configuration.isLogged = false;
    }

    /**
     * @Info Auth
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-20
     */
    auth() {

        if (this.user.user == null || this.user.user == "" || this.user.pass == null || this.user.pass == ""){
            let alert = this.alertCtrl.create({
                title: this._configuration.msgTitles,
                subTitle: 'Enter a valid username and password',
                buttons: ['OK']
            });
            alert.present();
        }else{

            if (this.isLoaderReady){
                this.loader.present();
            }

            let data = {"user":this.user.user,"password":this.user.pass};
            this.authService.auth(data)
                .then(data => {
                    this.response = data;

                    if (this.isLoaderReady) {
                        this.loader.dismiss();
                        this.isLoaderReady = false;
                    }
                    this.user.pass = null;

                    if (this.response.Success && !this.response.Error){
                        this.authsuccess(this.response);
                    }else{
                        let msg = this.response.Message;
                        if (this.response.Error){
                            msg = this.response.ErrorMessage;
                        }
                        let alert = this.alertCtrl.create({
                            title: this._configuration.msgTitles,
                            subTitle: msg,
                            buttons: ['OK']
                        });
                        alert.present();
                    }
                });
        }
    }


    /**
     * @Info Success Auth
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-20
     */
    authsuccess(response) {

        this._configuration.CustomerData.CustomerName = response.Content.CustumerName;
        this._configuration.CustomerData.IdBranch = response.Content.IdBranch;
        this._configuration.CustomerData.IdUser = response.Content.IdUser;
        this._configuration.CustomerData.Tax = response.Content.Tax;
        this._configuration.token = response.Content.Token;
        this._configuration.isLogged = true;

        this.navCtrl.push(HomePage).then(() => {
            const index = this.navCtrl.getActive().index;
            this.navCtrl.remove(0, index);
        });
    }


    show(){
        this.showLogin = !this.showLogin;
    }

    goToPos() {
        this.user.user = null;
        this.user.pass = null;
        this._configuration.isLogged = false;
        //this.navCtrl.push(PosTabsPage);
        this.navCtrl.setRoot(PosTabsPage);
    }

}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts